<template>
  <div class="news-container">
    <!-- 上部分：标题和介绍 -->
    <div class="header-section">
      <div class="content-wrapper">
        <div class="text-content">
          <h1 class="title">NEWS</h1>
          <p class="description">
            This is a paragraph introducing the cross-border integration of six
            core functions of digital currency and traditional finance.
          </p>
        </div>
        <div class="header-image">
          <img
            :src="require('@/assets/imgsnew/page8-4.svg')"
            alt="Header Decoration"
          />
        </div>
      </div>
    </div>

    <!-- 下部分：滑动新闻卡片 -->
    <div class="news-section">
      <div class="news-container-wrapper">
        <div
          class="news-slider"
          ref="slider"
          @mousedown="startDragging"
          @mousemove="onDragging"
          @mouseup="stopDragging"
          @mouseleave="stopDragging"
        >
          <div
            class="news-card"
            v-for="(news, index) in newsItems"
            :key="index"
          >
            <div class="card-icon">
              <img
                :src="require('@/assets/imgsnew/page8-1.svg')"
                alt="News Icon"
              />
            </div>
            <div class="card-content">
              <div class="card-text">
                <h3>{{ news.title }}</h3>
                <p>{{ news.description }}</p>
              </div>
              <div class="card-image">
                <img
                  :src="require(`@/assets/imgsnew/${news.image}`)"
                  :alt="news.title"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsPage",
  data() {
    return {
      newsItems: [
        {
          title: "Deposit in US dollars, no matter where you are",
          description:
            "Withdraw local currency anytime, anywhere. Conveniently control your funds and facilitate your travel life",
          image: "page8-2.svg",
        },
        {
          title: "Deposit in US dollars, no matter where you are",
          description:
            "Withdraw local currency anytime, anywhere. Conveniently control your funds and facilitate your travel life",
          image: "page8-3.svg",
        },
      ],
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
    };
  },
  methods: {
    startDragging(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.slider.offsetLeft;
      this.scrollLeft = this.$refs.slider.scrollLeft;

      // 添加抓取效果
      this.$refs.slider.style.cursor = "grabbing";
      this.$refs.slider.style.userSelect = "none";
    },

    onDragging(e) {
      if (!this.isDragging) return;
      e.preventDefault();

      const x = e.pageX - this.$refs.slider.offsetLeft;
      const walk = (x - this.startX) * 2; // 滚动速度倍数
      this.$refs.slider.scrollLeft = this.scrollLeft - walk;
    },

    stopDragging() {
      this.isDragging = false;
      // 恢复默认效果
      this.$refs.slider.style.cursor = "grab";
      this.$refs.slider.style.removeProperty("user-select");
    },
  },
};
</script>

<style scoped>
.news-container {
  padding: 30px 15px;
  margin-left: 40px;
}

.header-section {
  margin-bottom: 60px;
}

.content-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.text-content {
  flex: 1.2;
  padding-right: 20px;
}

.title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 16px;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
}

.header-image {
  flex: 0.8;
  display: flex;
  justify-content: flex-end;
}

.header-image img {
  max-width: 100%;
  height: auto;
  /* transform: rotate(30deg); */
  transform-origin: center center;
}

.news-section {
  position: relative;
  width: 100%;
  overflow: visible;
}

.news-container-wrapper {
  padding-left: 100px;
  margin-right: -40px;
  width: 100%;
  overflow: visible;
}

.news-slider {
  display: flex;
  gap: 30px;
  padding: 20px 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  cursor: grab; /* 添加抓取光标 */
  user-select: none; /* 防止文本选中 */
}

.news-slider:active {
  cursor: grabbing;
}

.news-slider::-webkit-scrollbar {
  display: none;
}

.news-card {
  min-width: 480px;
  border: 1px solid #000;
  padding: 24px;
  position: relative;
  background: #fff;
  flex-shrink: 0;
}

.news-card:last-child {
  margin-right: 140px;
}

.card-icon {
  position: absolute;
  top: -15px;
  left: 24px;
  background: #fff;
  padding: 0 10px;
}

.card-icon img {
  width: 30px;
  height: auto;
}

.card-content {
  display: flex;
  gap: 20px;
  align-items: center;
}

.card-text {
  flex: 1.2;
}

.card-text h3 {
  font-size: 20px;
  margin-bottom: 12px;
}

.card-text p {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
}

.card-image {
  flex: 0.8;
}

.card-image img {
  width: 100%;
  height: auto;
  max-width: 180px;
  margin-left: -10px;
}

@media (max-width: 768px) {
  .news-container {
    padding: 20px 15px;
    margin-left: 0;
  }

  /* 调整滑动容器为上下布局 */
  .news-slider {
    flex-direction: column;
    gap: 20px;
    padding: 15px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .news-container-wrapper {
    padding-left: 15px;
    padding-right: 15px;
  }

  /* 调整卡片样式 */
  .news-card {
    min-width: unset;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 20px;
    border-radius: 8px;
  }

  .news-card:last-child {
    margin-right: 0;
  }

  /* 保持卡片内容为左文案右图片 */
  .card-content {
    flex-direction: row;
    gap: 15px;
    align-items: center;
  }

  .card-text {
    flex: 1.5;
    text-align: left;
  }

  .card-text h3 {
    font-size: 16px;
    margin-bottom: 8px;
    line-height: 1.4;
  }

  .card-text p {
    font-size: 14px;
    line-height: 1.4;
  }

  .card-image {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  .card-image img {
    max-width: 120px;
    height: auto;
    object-fit: contain;
  }

  .card-icon {
    top: -12px;
    left: 20px;
  }

  .card-icon img {
    width: 24px;
  }

  .title {
    font-size: 42px;
    margin-bottom: 20px;
  }

  .description {
    font-size: 14px;
    line-height: 1.6;
    padding: 0;
    margin: 0 auto;
    margin-bottom: 30px;
    max-width: 95%;
    width: 100%;
  }

  .text-content {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    padding: 0;
  }

  .content-wrapper {
    max-width: 92.444vw;
    margin: 0 auto;
    padding: 0;
  }
}

/* 更小屏幕的适配 */
@media (max-width: 480px) {
  .news-card {
    padding: 15px;
  }

  .card-content {
    gap: 10px;
  }

  .card-text h3 {
    font-size: 14px;
  }

  .card-text p {
    font-size: 12px;
  }

  .card-image img {
    max-width: 100px;
  }

  .title {
    font-size: 36px;
  }

  .description {
    font-size: 13px;
    padding: 0;
    max-width: 95%;
  }

  .content-wrapper {
    padding: 0 15px;
  }

  .text-content {
    max-width: 400px;
  }
}
</style>
